import { useTranslation } from "react-i18next";
import useLeftMenuStore from "../../../stores/leftMenuStore";
import { ConstantRoutes } from "../../../core/constantRoutes";
import Dropdown from "../../dropdown/dropdown";
import { useAuthStore } from "../../../stores/authStore";
import AuthServiceInstance from "../../../api/authServices";
import { useLocation, useNavigate } from "react-router-dom";
import { useModalAuthorizationStore } from "../../../stores/modalAuthorizationStore";
import EmailInitial from "../../common/emailInitial";

const MainMdMenu: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isOpen, setIsOpen } = useLeftMenuStore();
  const { isAuthenticated, authorizedEmail } = useAuthStore();
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const handleItemClick = (route: string) => {
    setIsOpen(false);
    navigate(`#${route}`);
  };

  return (
    <div
      className={`fixed top-10 left-0 w-full h-full flex flex-col items-center justify-center bg-[#10121B] z-49
     md:hidden ${isOpen ? "" : "hidden"} `}
    >
      <div className="flex flex-col items-center text-center justify-evenly">
        <div className="py-3">
          {isHomePage ? (
            <a
              href={ConstantRoutes.about}
              className="text-textsecondary transition-all duration-300 hover:text-white text-3xl"
            >
              {t("About")}
            </a>
          ) : (
            <a
              href={ConstantRoutes.home}
              className="text-textsecondary transition-all duration-300 hover:text-white text-3xl"
            >
              {t("Home")}
            </a>
          )}
        </div>

        <div className="py-3">
          <a
            href={
              isHomePage
                ? `#${ConstantRoutes.pricing}`
                : `/#${ConstantRoutes.pricing}`
            }
            onClick={() => handleItemClick(ConstantRoutes.pricing)}
            className="text-textsecondary transition-all duration-300 hover:text-white text-3xl"
          >
            {t("Pricing")}
          </a>
        </div>
        <div className="py-3">
          <a
            href={
              isHomePage
                ? `#${ConstantRoutes.news}`
                : `/#${ConstantRoutes.news}`
            }
            onClick={() => handleItemClick(ConstantRoutes.news)}
            className="text-textsecondary transition-all duration-300 hover:text-white text-3xl"
          >
            {t("News")}
          </a>
        </div>
        <div className="py-3">
          <a
            href={
              isHomePage ? `#${ConstantRoutes.faq}` : `/#${ConstantRoutes.faq}`
            }
            onClick={() => handleItemClick(ConstantRoutes.faq)}
            className="text-textsecondary transition-all duration-300 hover:text-white text-3xl"
          >
            {t("FAQ")}
          </a>
        </div>
      </div>

      <div className="w-full p-8">
        {isAuthenticated() && (
          <div className="p-4">
            <div className="flex items-center bg-content3 p-4 rounded-xl">
              <EmailInitial email={authorizedEmail} />

              <Dropdown
                items={[
                  { id: "profile", label: t("Profile") },
                  { id: "quit", label: t("Exit") },
                ]}
                onSelect={function (item: { id: string; label: string }): void {
                  if (item.id === "quit") {
                    AuthServiceInstance.logout();
                    navigate(ConstantRoutes.main);
                  }
                }}
                caption={authorizedEmail ?? "ERROR"}
                reverseDirection={true}
              />
            </div>
          </div>
        )}

        {!isAuthenticated() && (
          <>
            <button
              className="border border-primary rounded-md w-full h-10 items-center 
                      justify-center bg-primary hover:animate-pulse transition duration-300 ease-in-out mr-4
                      mb-4"
              onClick={() =>
                useModalAuthorizationStore.setState({
                  modalOpen: true,
                  activeTab: "login",
                })
              }
            >
              {t("Sign In")}
            </button>
            <button
              className="rounded-md w-full h-10 items-center 
                      justify-center hover:bg-primary transition duration-300 ease-in-out"
              onClick={() =>
                useModalAuthorizationStore.setState({
                  modalOpen: true,
                  activeTab: "register",
                })
              }
            >
              {t("Sign Up")}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default MainMdMenu;
